import { useEffect, useRef } from 'react';

import SafeHTML from '../SafeHTML';
import {
  Text,
} from 'web-styled';

interface Props {
  html: string;
  size?: string;
  className?: string;
  addRelNoopener?: boolean;
}

export default function HelpText({ html, className, addRelNoopener = true, ...rest }: Props) {
  const ref = useRef<HTMLSpanElement | null>(null);

  useEffect(() => {
    const root = ref.current;
    if (!root) return;

    const onPointerDown = (ev: PointerEvent) => {
      // find the closest anchor from event target up to root
      let el = ev.target as Element | null;
      while (el && el !== root) {
        if (el.tagName === 'A') {
          // stop the mousedown-like behavior that blurs inputs before click fires
          ev.preventDefault();
          // do not stopPropagation: we still want click to be delivered
          return;
        }
        el = el.parentElement;
      }
    };

    // capture phase so it runs before focus/blur side-effects
    root.addEventListener('pointerdown', onPointerDown, { capture: true });

    return () => {
      root.removeEventListener('pointerdown', onPointerDown, { capture: true });
    };
  }, []);

  return (
    <span ref={ref}>
      <SafeHTML
        {...rest}
        as={Text}
        html={html}
        addRelNoopener={addRelNoopener}
        color="#9EA0A1"
        whiteSpace="pre-line"
        className={className}
      />
    </span>
  )
}
